import window from 'global/window';
var history = [];
var LogByTypeFactory = function LogByTypeFactory(name, log) {
    return function (type, level, args) {
        var lvl = log.levels[level];
        var lvlRegExp = new RegExp('^('.concat(lvl, ')$'));
        if (type !== 'log') {
            args.unshift(type.toUpperCase() + ':');
        }
        args.unshift(name + ':');
        if (history) {
            history.push([].concat(args));
        }
        if (!window.console) {
            return;
        }
        var fn = window.console[type];
        if (!fn && type === 'debug') {
            fn = window.console.info || window.console.log;
        }
        if (!fn || !lvl || !lvlRegExp.test(type)) {
            return;
        }
        fn[Array.isArray(args) ? 'apply' : 'call'](window.console, args);
    };
};
export default function createLogger(name) {
    var level = 'info';
    var logByType;
    var log = function log() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        logByType('log', level, args);
    };
    logByType = LogByTypeFactory(name, log);
    log.createLogger = function (subname) {
        return createLogger(name + ': ' + subname);
    };
    log.levels = {
        all: 'debug|log|warn|error',
        off: '',
        debug: 'debug|log|warn|error',
        info: 'log|warn|error',
        warn: 'warn|error',
        error: 'error',
        DEFAULT: level
    };
    log.level = function (lvl) {
        if (typeof lvl === 'string') {
            if (!log.levels.hasOwnProperty(lvl)) {
                throw new Error('"'.concat(lvl, '" in not a valid log level'));
            }
            level = lvl;
        }
        return level;
    };
    log.history = function () {
        return history ? [].concat(history) : [];
    };
    log.history.filter = function (fname) {
        return (history || []).filter(function (historyItem) {
            return new RegExp('.*'.concat(fname, '.*')).test(historyItem[0]);
        });
    };
    log.history.clear = function () {
        if (history) {
            history.length = 0;
        }
    };
    log.history.disable = function () {
        if (history !== null) {
            history.length = 0;
            history = null;
        }
    };
    log.history.enable = function () {
        if (history === null) {
            history = [];
        }
    };
    log.error = function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }
        return logByType('error', level, args);
    };
    log.warn = function () {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }
        return logByType('warn', level, args);
    };
    log.debug = function () {
        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }
        return logByType('debug', level, args);
    };
    return log;
}